/**
 * Schedule API — versão tipada
 */
import { base } from '@/utils/api'

export default {
  getProfessionalsAndRooms(clinicId: number) {
    return base.get(`schedule/${clinicId}/professionals-rooms`)
  },

  getAppointments(clinicId: number, params: Record<string, any>) {
    return base.get('appointments/getScheduleAppointments', {
      params: { ...params, clinicId }
    })
  },

  getSurgicalMapData(clinicId: number, start: string, filters?: any) {
    return base.get(`surgical-map/${clinicId}`, {
      params: { start, filters }
    })
  },

  getRoomReservationByDay(clinicId: number, date: string, filters?: any) {
    return base.get(`roomReservations-getByDay/${clinicId}/${date}`, {
      params: { filters }
    })
  }
}
